import { render, staticRenderFns } from "./ConfirmEmailPage.vue?vue&type=template&id=8e5e45e8"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports